module.exports = __webpack_public_path__ + "img/btn_menu_all_c.5dee7eee.png";